const text = value => String(value || "").replace(/\s+/g, " ").trim();
const length = value => [...value].length;
export function wordLimit(value, max) {
  const words = text(value).split(" ");
  while (length(words.join(" ")) > max && words.length > 1) words.pop();
  return words.join(" "); // An indivisible oversized keyword is reported, never cut.
}
export function seoTitle(value) {
  let title = text(value);
  if (length(title) > 65) title = title.replace(/\s*\|\s*(?:BookAclassic|DriveShare)\s*$/i, "");
  return wordLimit(title, 65);
}
export function seoDescription(value, pageTitle) {
  let description = text(String(value || "").replace(/<[^>]*>/g, " "));
  if (length(description) < 70) {
    const context = text(pageTitle).replace(/\s*\|[^|]+$/, "");
    description = text(`${description || context}. Explore photographs, detailed information and local classic car options on this page.`);
  }
  return wordLimit(description, 160);
}
const decode = value => value.replace(/&(?:amp|quot|apos|lt|gt|#39|#(\d+)|#x([\da-f]+));/gi,
  (match, decimal, hex) => decimal || hex ? String.fromCodePoint(parseInt(decimal || hex, hex ? 16 : 10))
    : ({ "&amp;": "&", "&quot;": '"', "&apos;": "'", "&lt;": "<", "&gt;": ">", "&#39;": "'" }[match.toLowerCase()] || match));
const escape = value => value.replaceAll("&", "&amp;").replaceAll('"', "&quot;").replaceAll("<", "&lt;").replaceAll(">", "&gt;");
export function normalizeDocumentSeo(html) {
  const title = seoTitle(decode(html.match(/<title\b[^>]*>([\s\S]*?)<\/title>/i)?.[1] || ""));
  const descriptionTag = html.match(/<meta\b(?=[^>]*\bname=["']description["'])[^>]*>/i)?.[0];
  const oldDescription = descriptionTag?.match(/\bcontent=(["'])([\s\S]*?)\1/i)?.[2] || "";
  const description = seoDescription(decode(oldDescription), title);
  let result = html.replace(/<title\b[^>]*>[\s\S]*?<\/title>/i, `<title>${escape(title)}</title>`);
  result = descriptionTag ? result.replace(descriptionTag, `<meta name="description" content="${escape(description)}">`)
    : result.replace("</head>", `<meta name="description" content="${escape(description)}"></head>`);
  return result.replace(/<meta\b(?=[^>]*(?:property|name)=["'](?:og|twitter):(title|description)["'])[^>]*>/gi,
    (tag, kind) => tag.replace(/\bcontent=(["'])([\s\S]*?)\1/i, `content="${escape(kind === "title" ? title : description)}"`));
}
export function onPageSeoChecks(html, { indexable = true } = {}) {
  const visible = html.replace(/<(script|style|noscript)\b[^>]*>[\s\S]*?<\/\1>/gi, "").replace(/<!--[\s\S]*?-->/g, "");
  const title = decode(html.match(/<title\b[^>]*>([\s\S]*?)<\/title>/i)?.[1] || "");
  const descriptionTag = html.match(/<meta\b(?=[^>]*\bname=["']description["'])[^>]*>/i)?.[0] || "";
  const description = decode(descriptionTag.match(/\bcontent=(["'])([\s\S]*?)\1/i)?.[2] || "");
  const images = [...visible.matchAll(/<img\b[^>]*>/gi)].map(([tag]) => tag);
  return {
    title: length(title) > 0 && length(title) <= 65,
    description: !indexable || length(description) >= 70 && length(description) <= 160,
    imageAlt: images.every(tag => /\balt\s*=\s*(["'])([\s\S]*?)\1/i.test(tag)),
    oneH1: [...visible.matchAll(/<h1\b[^>]*>/gi)].length === 1,
  };
}
